import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PlusIcon } from "../assets/Icons";
import SearchBox from "../components/common/SearchBox";
import apiClient from "../apiClient";
import { GET_CHANNEL_WITH_DIRECTORY_LIST } from "../apiClient/apiEndpoints";
import { SSO_URL } from "../env";
import { getPlaceholderName } from "../utils/general";
import NoDataFound from "../components/common/NoDataFound";

const Channels = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCurrentChannels = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(`${SSO_URL}${GET_CHANNEL_WITH_DIRECTORY_LIST}`);
      setChannels(response.channels);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const filteredchannels = useMemo(() => {
    if (!search) return channels;
    return channels?.filter?.((item) => item.name?.toLowerCase()?.includes(search?.toLowerCase()));
  }, [search, channels?.length]);

  useEffect(() => {
    fetchCurrentChannels();
  }, []);

  return (
    <>
      <div className="main-list">
        <div className="page-title">
          <h5>Channels</h5>
        </div>
      </div>
      <div className="section  p-4 pt-0">
        <div className="tags-sort my-3">
          <SearchBox search={search} setSearch={setSearch} />
          <button className="DefaultRedBtn" onClick={() => navigate(`/dashboard/channels/create`)}>
            <PlusIcon />
            Create Channel
          </button>
        </div>

        {filteredchannels.length > 0 ? (
          <div className="list-view channels">
            <div className="list-here">
              {filteredchannels?.map((item) => {
                return (
                  <div className="channel-card" onClick={() => navigate(`/dashboard/channels/info/${item.uuid}`)}>
                    <span className="channel-logo">
                      <img src={item?.group?.avatar || "https://cdn.simulanis.io/sso/logos/default_simulanis.png"} />
                    </span>
                    <span className="channel-detail">
                      <div className="details">
                        <div className="detail-item mt-0">
                          <h6>Channel Details</h6>
                          <span>
                            <p>
                              Name: <span>{item.name}</span>{" "}
                            </p>
                            <p>
                              UUID: <span>{item.uuid}</span>{" "}
                            </p>
                          </span>
                        </div>
                        <div className="detail-item">
                          <h6>Default Group Details </h6>
                          <span>
                            <p>
                              Name:
                              <span>
                                <DisplayImage path={item?.group?.avatar || null} name={item?.group?.name || ""} />
                                {item?.group?.name}
                              </span>
                            </p>
                            <p>
                              UUID: <span>{item?.group?.uuid}</span>
                            </p>
                          </span>
                        </div>
                        <div className="detail-item">
                          <h6>Directory Details</h6>
                          <span>
                            <p>
                              Name: <span>{item?.directory?.name}</span>
                            </p>
                          </span>
                        </div>
                      </div>
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : loading ? (
          <NoDataFound text="Fetching Data..." />
        ) : (
          <NoDataFound text="No channel found" />
        )}
      </div>
    </>
  );
};

export default Channels;

export const DisplayImage = ({ path = null, name = "" }) => {
  const [error, setError] = useState(false);
  return (
    <>
      {path && !error ? (
        <img src={path} onError={() => setError(true)} />
      ) : (
        <span className="initial-small">{getPlaceholderName(name)}</span>
      )}
    </>
  );
};
